<div class="dialog-header">
  <div class="dialog-title-container">
    <mat-icon [h3CustomIcon]="finalizeSampleIcon"></mat-icon>
    <span class="subtitle-01 dialog-title">Finalize sample</span>
  </div>
</div>

@if ((isLoading$ | async) === false) {
  <span class="information-text body-02">
    @if (isLastUnreviewed) {
      Please note that once finalized, feedback can no longer be edited and
      tasks will remain in the same state. Are you sure you want to finalize?
    } @else {
      You haven’t reviewed all tasks. Please note that once finalized, feedback
      can no longer be edited and tasks will remain in the same state. Are you
      sure you want to finalize?
    }
  </span>

  <mat-dialog-actions align="end">
    <button mat-button color="primary" mat-dialog-close>CANCEL</button>
    <button mat-button color="primary" (click)="finalizeSample()">
      FINALIZE
    </button>
  </mat-dialog-actions>
} @else {
  <div class="loading-container">
    <span class="caption">Finalizing sample...</span>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}
